<script setup lang="ts">
import { Ref, inject } from 'vue';
import { AIR_ONLY, HOTEL_ONLY, TOUR, PACKAGE, CRUISE } from '@/constants';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import CruisePriceBooking from '@/components/modal/priceBooking/CruisePriceBooking.vue';
import FileTotalPrice from '@/components/modal/priceBooking/FileTotalPrice.vue';
import FlightInfoBooking from '@/components/modal/priceBooking/FlightInfoBooking.vue';
import HotelInfoBooking from '@/components/modal/priceBooking/HotelInfoBooking.vue';
import PriceBookingTable from '@/components/modal/priceBooking/PriceBookingTable.vue';

const dialogRef = inject('dialogRef') as Ref;
const priceSummary = dialogRef?.value?.data?.priceSummary;
const quoteType = dialogRef?.value?.data?.quoteType;

const renderKeyTotalView = (quoteType: string) => {
  switch (quoteType) {
    case AIR_ONLY:
      return 'flightPrices';
    case TOUR:
      return 'tourHotels';
    case HOTEL_ONLY:
      return 'priceHotels';
    case CRUISE:
      return 'fileTotals';
    default:
      return 'packageHotels';
  }
};

const renderKeyOptionView = (quoteType: string) => {
  switch (quoteType) {
    case AIR_ONLY:
      return 'airInfos';
    case TOUR:
      return 'tourInfos';
    case HOTEL_ONLY:
      return 'hotelInfos';
    case CRUISE:
      return 'cruiseBreakdownInfo';
    default:
      return 'packageInfos';
  }
};

const totalSeatBookingFlight = (flights: any) => {
  const economy = flights?.find((flight: any) => flight.class === 'Economy');
  const business = flights?.find((flight: any) => flight.class === 'Business');
  return economy.totalSeats + business.totalSeats;
};
</script>
<template>
  <div class="price-booking-summary">
    <div>
      <div class="mb-2">
        <span> {{ $t('book_form.booking_price_summary.title_first') }} </span> <span class="underline"> {{ ` ${$t('book_form.booking_price_summary.strong_title')}` }}</span>
      </div>
      <div>
        {{ $t('book_form.booking_price_summary.title_second') }}
      </div>
    </div>
    <div class="mb-2">
      <div class="lead-option">{{ $t('book_form.booking_price_summary.file_totals') }} ({{ $t('book_form.booking_price_summary.all_options') }})</div>
    </div>
    <div v-for="(detailPrice, index) in priceSummary[renderKeyTotalView(quoteType)]" :key="index">
      <FileTotalPrice :quoteType="quoteType" :detailPrice="detailPrice" :indexOption="index" />
    </div>

    <Tabs :value="0">
      <TabList>
        <Tab v-for="(_, index) in priceSummary[renderKeyOptionView(quoteType)]" :key="index" :value="index">{{ $t('common.option') + ' ' + Number(index + 1) }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel v-for="(option, index) in priceSummary[renderKeyOptionView(quoteType)]" :key="index" :value="index">
          <div v-if="quoteType === PACKAGE || quoteType === HOTEL_ONLY || quoteType === TOUR">
            <div class="mb-5" v-for="(hotel, indexHotel) in option.hotels" :key="indexHotel">
              <div v-if="hotel?.infoPriceBreakdownCommon.numOfRooms">
                <HotelInfoBooking :priceData="hotel.packageRoomsPrice" :infoData="hotel?.infoPriceBreakdownCommon" :quoteType="quoteType" :option="index" />
                <div class="room-pricing">
                  <div v-for="(room, indexRoom) in hotel.packageRoomsPrice" :key="indexRoom">
                    <PriceBookingTable :quoteType="quoteType" :dataPricing="room" :infoData="hotel?.infoPriceBreakdownCommon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="quoteType === AIR_ONLY">
            <div class="mb-2">
              <div v-if="totalSeatBookingFlight(option?.infoPriceBreakdownCommon?.infoClasses)">
                <FlightInfoBooking :infoData="option?.infoPriceBreakdownCommon" />
                <div class="room-pricing">
                  <div v-for="(air, indexAirDetail) in option.flightPrice" :key="indexAirDetail">
                    <PriceBookingTable :quoteType="quoteType" :dataPricing="air" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="quoteType === CRUISE">
            <div class="mb-2"><CruisePriceBooking :quoteType="quoteType" :cruiseData="option" /></div>
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
